import { render, staticRenderFns } from "./appProtocol.vue?vue&type=template&id=55b7fa02&"
import script from "./appProtocol.vue?vue&type=script&lang=js&"
export * from "./appProtocol.vue?vue&type=script&lang=js&"
import style0 from "./appProtocol.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports